<template>
    <div>
        <b-modal
            title="Achtung: unabgespeicherte Daten"
            v-model="modalCloseDialogueState"
            centered
        ><!-- modal -->
            <div>
               <p>Sie haben Addressänderungen vorgenommen, aber nicht abgespeichert. Sind Sie sich sicher, dass sie das Edit-Fenster schliessen wollen?</p>
            </div>
            <div slot="modal-footer" class="w-100">
               <b-button
                  size="md"
                  class="float-right mx-1"
                  variant="danger"
                  @click="modalCloseDialogue('confirm')"
               >verwerfen</b-button>
               <b-button size="md" class="float-right" @click="modalCloseDialogue('abort')">beibehalten</b-button>
            </div>
         </b-modal>
        <b-modal
            title="Addresse Speichern"
            v-model="modalSuccessDialogue"
            centered
        ><!-- modal -->
            <div>
               <p>Die Addresse wurde erfolgreich für die Bestellung <b>{{customerOrderId}}</b> abgespeichert.</p>
            </div>
            <div slot="modal-footer" class="w-100">
               <b-button
                  size="md"
                  class="float-right mx-1"
                  variant="success"
                  @click="visible = false; modalSuccessDialogue = false"
               >schliessen</b-button>
            </div>
         </b-modal>
        <b-modal
            title="Adresse bearbeiten"
            v-model="visible"
            size="xl"
        ><!-- modal -->
            <b-overlay
                id="overlay-background-dropdown"
                :show="queryInProgress"
                spinner-type="grow"
                rounded="lg"
                spinner-small
            ><!-- overlay -->
              <b-alert :show="addressChanged" variant="warning">Sie haben unabgespeicherte Änderungen offen.</b-alert>
            <br v-if="addressChanged" />
            <b>Allgemein</b>
            <form class="pr-3">
                <b-form inline class="py-2" @submit="handleSubmit">
                    <label class="mr-2 col-3 text-right">Anrede:</label>
                    <b-input size="sm" class="mr-1 inputsf" v-model="lAddress.salutation" />
                </b-form>

                <b-form inline class="py-2" @submit="handleSubmit">
                    <label class="mr-2 col-3 text-right" >Firma:</label>
                    <b-input size="sm" class="mr-1 inputsf" v-model="lAddress.company" />
                </b-form>

                <b-form inline class="py-2" @submit="handleSubmit">
                    <label class="mr-2 col-3 text-right">Vorname:</label>
                    <b-input size="sm" class="mr-1 inputsf" v-model="lAddress.firstName" />
                </b-form>

                <b-form inline class="py-2" @submit="handleSubmit">
                    <label class="mr-2 col-3 text-right">Nachname:</label>
                    <b-input size="sm" class="mr-1 inputsf" v-model="lAddress.lastName" />
                </b-form>
            </form>
            <hr/>
            <b>Adresse</b>
            <form class="pr-3">
                <b-form inline class="py-2" @submit="handleSubmit">
                    <label class="mr-2 col-3 text-right">Strasse:</label>
                    <b-input size="sm" class="mr-1 inputsf" v-model="lAddress.street" />
                </b-form>

                <b-form inline class="py-2" @submit="handleSubmit">
                    <label class="mr-2 col-3 text-right">Strasse 2:</label>
                    <b-input size="sm" class="mr-1 inputsf" v-model="lAddress.street2" />
                </b-form>

                <b-form inline class="py-2" @submit="handleSubmit">
                    <label class="mr-2 col-3 text-right">Strasse 3:</label>
                    <b-input size="sm" class="mr-1 inputsf" v-model="lAddress.street3" />
                </b-form>

                <b-form inline class="py-2" @submit="handleSubmit">
                    <label class="mr-2 col-3 text-right">PLZ:</label>
                    <b-input size="sm" class="mr-1 inputsf" v-model="lAddress.zipCode" />
                </b-form>

                <b-form inline class="py-2" @submit="handleSubmit">
                    <label class="mr-2 col-3 text-right">Stadt:</label>
                    <b-input size="sm" class="mr-1 inputsf"  v-model="lAddress.city"  />
                </b-form>

                <b-form inline class="py-2" @submit="handleSubmit">
                    <label class="mr-2 col-3 text-right">Bundesland:</label>
                    <b-input size="sm" class="mr-1 inputsf"  v-model="lAddress.state" />
                </b-form>
            </form>
            <hr/>

            <b>Kontakt</b>
            <form class="pr-3">
                <b-form inline class="py-2" @submit="handleSubmit">
                    <label class="mr-2 col-3 text-right">E-Mail:</label>
                    <b-input size="sm" class="mr-1 inputsf"  v-model="lAddress.email" />
                </b-form>

                <b-form inline class="py-2" @submit="handleSubmit">
                    <label class="mr-2 col-3 text-right">Telefon:</label>
                    <b-input size="sm" class="mr-1 inputsf" v-model="lAddress.phone" />
                </b-form>

                <b-form inline class="py-2" @submit="handleSubmit">
                    <label class="mr-2 col-3 text-right">Fax:</label>
                    <b-input size="sm" class="mr-1 inputsf" v-model="lAddress.fax" />
                </b-form>

                <b-form inline class="py-2" @submit="handleSubmit">
                    <label class="mr-2 col-3 text-right">Mobil:</label>
                    <b-input size="sm" class="mr-1 inputsf"  v-model="lAddress.mobile" />
                </b-form>
            </form>
            <hr/>
            <b>Zusatzdaten</b>
            <form class="pr-3">
                <b-form inline class="py-2" @submit="handleSubmit">
                    <label class="mr-2 col-3 text-right">E-Ust-Id:</label>
                    <b-input size="sm" class="mr-1 inputsf"  v-model="lAddress.taxId" />
                </b-form>
                <b-form inline class="py-2" @submit="handleSubmit">
                    <label class="mr-2 col-3 text-right">Land (Alternativ):</label>
                    <b-input size="sm" class="mr-1 inputsf" v-model="lAddress.countryClear" />
                </b-form>
                <b-form inline class="py-2" @submit="handleSubmit">
                    <label class="mr-2 col-3 text-right">Show countryname:</label>
                    <!-- b-input size="sm" class="mr-1 inputsf"  / -->
                    <b-form-select
                        v-model="lAddress.countryId"
                        :options="countryOptions"
                        size="sm"
                        class="mt-3"
                    ></b-form-select>
                </b-form>
            </form>
            </b-overlay>

            <div slot="modal-footer" class="w-100">
                <b-button
                    :disabled="queryInProgress || (!addressChanged)"
                    size="md"
                    class="float-right mx-1"
                    variant="primary"
                    @click="save()"
                ><!-- button -->
                    <span>speichern</span>
                </b-button>
                <b-button
                    :disabled="queryInProgress"
                    size="md"
                    class="float-right"
                    @click="close()"
                ><!-- button -->
                    <span v-if="addressChanged">verwerfen</span>
                    <span v-else>schliessen</span>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>
<style>
    .inputsf { min-width: 70% !important; }
</style>
<script>
export default {
    props: [ 'address', 'countries', 'customerOrderId' ],
    data() {
        return {
            visible: false,
            modalCloseDialogueState: false,
            modalSuccessDialogue:false,
            queryInProgress: false,
            // countryOptions: [
            //     { value: null, text: 'Please select an option' }
            // ],
            lAddress: {
                id: ""
                , salutation:""
                , company: ""
                , firstName: ""
                , lastName: ""
                , street: ""
                , street2: ""
                , street3: ""
                , city: ""
                , state: ""
                , zipCode: ""
                , email: ""
                , fax: ""
                , phone: ""
                , mobile: ""
                , taxId: ""
                , birthday: ""
                , likesNewsletter: ""
                , customerState: ""
                , isBlocked: ""
                , customerGroup: ""
                , priority: ""
                , currentState: ""
                , lastUpdateTime: ""
                , lastUpdateUser: ""
                , lastUpdateReason: ""
                , countryClear: ""
                , countryId: ""
                , addressTypeId: ""
            }
        }
    },
    computed: {
        countryOptions: function() {
            if(!this.countries) return [];
            return this.countries.map( function(c) {
                return { value: c.id, text: c.countryName }
            });
        },
        addressChanged: function() {
            // if success dialogue is being shown, we just updated the address and there are no pending changes.
            if(this.modalSuccessDialogue) return false;
            // check if lAddress and address are different
            for(let key of Object.keys(this.lAddress))
            {
                if(key != 'country')//this is a very big problem, it turns out
                {
                    if( ((this.address[key])  ? this.address[key] : "")
                    !== ((this.lAddress[key]) ? this.lAddress[key] : "")
                    ){
                        return true;
                    }
                }
            }

            return false;
        }

    },
    methods: {
        modalCloseDialogue(choice) {
            if( "confirm" === choice ) {
                this.lAddress = _.cloneDeep(this.address);
                this.visible = false;
            }else if( "abort" == choice ){
                //do nothing
            }

            this.modalCloseDialogueState = false;
        },
        handleSubmit() {
            // wtf is this?
        },
        save() {
            // console.log("COIAddressEdit.save() called");
            if(this.addressChanged) {
                this.queryInProgress = true;
                const historyEntry = {
                    customerOrderId: this.customerOrderId
                  , comment: "Addresse wurde bearbeitet."
                };
                Promise.all([
                    axios.post('/address/update', this.lAddress)
                  , axios.post('/customerorder/inserthistory', historyEntry)
                  , new Promise( r => setTimeout(r, 500) )
                ]).then( ([response, rcoh]) => {
                    this.queryInProgress = false;
                    console.log('new addr resp', response);
                    this.lAddress = _.cloneDeep(response.data);
                    this.$emit( 'mutatedAddress', {
                         customerOrderId: this.customerOrderId
                       , rawAddress: _.cloneDeep(response.data)
                       , customerOrderHistory: rcoh.data
                    });

                    this.modalSuccessDialogue = true;
                }).catch( error => {
                    this.queryInProgress = false;
                    alert("Speichervorgang ist fehlgeschlagen.");
                    console.error(error);
                });
            }
        },
        open() {
            this.visible = true;
        },
        close()
        {
            if(this.addressChanged)
            {
                this.modalCloseDialogueState = true;
            }
            else
            {
                this.visible = false;
            }
        }
    },
    created() {
        this.lAddress = _.cloneDeep(this.address);
    }
}
</script>
